export default {
  setCouponData(state, payload) {
    state.couponData = payload;
  },
  setCurWatchFun(state, payload) {
    state.curWatchFun = payload;
  },
  setTrainBannerData(state, payload) {
    state.trainBannerData = payload
  },
};
